import { Card, CardContent } from "@/components/ui/card";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "@/lib/utils";

export function HeroMockup() {
  return (
    <Card className="mx-auto max-w-xs shadow-lg">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-2xl">🧒</span>
            <div>
              <p className="font-display font-bold text-sm">Emils dag</p>
              <p className="text-xs text-muted-foreground">Tirsdag 18. feb</p>
            </div>
          </div>
          <span className="inline-flex items-center rounded-full bg-accent px-2 py-0.5 text-[10px] font-semibold text-accent-foreground">
            Barnemodus
          </span>
        </div>
        <div className="space-y-2">
          {[
            { label: "Lese 15 min", done: true },
            { label: "Matteoppgave", done: true },
            { label: "Øve piano", done: false },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-sm">
              <div
                className={`h-4 w-4 rounded border flex items-center justify-center ${
                  item.done
                    ? "bg-primary border-primary text-primary-foreground"
                    : "border-border"
                }`}
              >
                {item.done && <span className="text-[10px]">✓</span>}
              </div>
              <span className={item.done ? "line-through text-muted-foreground" : ""}>
                {item.label}
              </span>
            </div>
          ))}
        </div>
        <div className="space-y-1">
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>Fremgang</span>
            <span>2 av 3</span>
          </div>
          <ProgressPrimitive.Root
            className={cn("relative h-2 w-full overflow-hidden rounded-full bg-secondary")}
            value={66}
          >
            <ProgressPrimitive.Indicator
              className="h-full w-full flex-1 bg-[hsl(var(--success))] transition-all"
              style={{ transform: `translateX(-${100 - 66}%)` }}
            />
          </ProgressPrimitive.Root>
        </div>
        <p className="text-center text-xs text-muted-foreground mt-1">⭐ 12 i dag</p>
        <p className="text-center text-[11px] text-muted-foreground">
          Barnet logger ikke inn – bare åpner sin dag.
        </p>
      </CardContent>
    </Card>
  );
}
